import { z } from 'zod';

export const CriarNovidadeZodSchema = z.object({
	tipoNovidade: z.number().min(1, 'Tipo de novidade é obrigatório'),
	descricao: z.string().max(300, 'Descrição é obrigatória'),
});

export type CriarNovidadeZodFormValues = z.infer<typeof CriarNovidadeZodSchema>;
